define('TescoMobile_Esim/js/view/minicart/cart-item-renderer-mixin',[],function () {
  'use strict';

  return function (renderer) {
    return renderer.extend({
      initialize: function () {
        this._super();
        this.extensionTemplates.esim.push('TescoMobile_Esim/minicart/esim-device.html');
        return this;
      }
    });
  };
});

